import CustomerReferralRegistration from '../customer-referral/registration';

export default class LoginRegister {
  elements;

  constructor() {
    this.elements = {
      section: document.querySelectorAll('.customer-login-register-section'),
      formTabs: document.querySelectorAll('.customer-auth__tab'),
      registrationButton: document.querySelector('.customer-auth__register [type="button"]'),
      loginButton: document.querySelector('.customer-auth__login [type="button"]'),
      loginErrors: document.querySelector('[data-form-login] .errors'),
      registrationErrors: document.querySelector('[data-form-register] .errors'),
      recoverPasswordLink: document.querySelector('[data-recover-password]'),
      recoverPasswordButton: document.querySelector('.customer-auth__recover-password [type="button"]'),
      loginRegisterContainer: document.querySelector('.container--login-register'),
      recoverPasswordContainer: document.querySelector('.container--recover-password'),
      backToLoginLink: document.querySelector('[data-back-to-login]'),
    };

    if (!this.elements.section.length) {
      return;
    }

    if (window.theme.isLoggedIn === true) {
      window.location.href = '/pages/astr-rewards';
      return;
    }

    // Listeners
    if (this.elements.formTabs.length) {
      // this.elements.formTabs.addEventListener('click', this.changeTab.bind(this));
      Array.from(this.elements.formTabs).forEach((element) => {
        element.addEventListener('click', this.changeTab.bind(this));
      });
    }

    if (this.elements.registrationButton !== null) {
      this.elements.registrationButton.addEventListener('click', this.handleRegistration.bind(this));
    }
    
    if (this.elements.loginButton !== null) {
      this.elements.loginButton.addEventListener('click', this.handleLogin.bind(this));
    }

    if (this.elements.recoverPasswordLink !== null) {
      this.elements.recoverPasswordLink.addEventListener('click', this.changeView.bind(this));
    }

    if (this.elements.recoverPasswordButton !== null) {
      this.elements.recoverPasswordButton.addEventListener('click', this.handleRecoverPassword.bind(this));
    }

    if (this.elements.backToLoginLink !== null) {
      this.elements.backToLoginLink.addEventListener('click', this.changeView.bind(this));
    }

    // Select the correct tab based on page url
    this.changeTab();

    // The recover hash is in the URL
    if (window.location.hash.includes('recover')) {
      this.changeView({ currentTarget: this.elements.recoverPasswordLink });
    }

    // Handle error messages
    this.handleErrors();

    // this.resetPasswordSuccess();
  }

  // Find out which tab is currently active
  getActiveTab = () => {
    let active_tab = 'register';
    document.querySelectorAll('.customer-auth__tab').forEach((tab) => {
      if (tab.classList.contains('active')) {
        active_tab = tab.dataset.authTabType;
      }
    });

    return active_tab;
  };

  handleErrors = () => {
    // We have to use a JS solution as it seems there's an issue with Shopify rendering the html directly
    document.querySelectorAll('.errors li').forEach((li) => {
      li.innerHTML = li.textContent;
    });

    // The form errors appear on both forms, so we need to check which form is currently active
    // and only display the errors for that form

    const activeTab = this.getActiveTab();
    if (activeTab === 'register' && this.elements.registrationErrors !== null && this.elements.registrationErrors.innerHTML.trim() !== '') {
      this.elements.registrationErrors.classList.remove('visually-hidden');
      this.elements.loginErrors.classList.add('visually-hidden');
    } else if (activeTab === 'login' && this.elements.loginErrors !== null && this.elements.loginErrors.innerHTML.trim() !== '') {
      this.elements.loginErrors.classList.remove('visually-hidden');
      this.elements.registrationErrors.classList.add('visually-hidden');
    }

    // The form messages could be for another login page
    const referral_login = window.localStorage.getItem('referral-login') || '';
    if (referral_login !== '') {
      const error_message_login = (this.elements.loginErrors && !this.elements.loginErrors.classList.contains('visually-hidden')) ? this.elements.loginErrors.innerHTML : '';

      if (error_message_login !== '') {
        window.localStorage.setItem('referral-login-errors', error_message_login);
        window.location.href = `/account/register?view=referral&form=login`;
        return;
      }
    }

    const referral_registration = window.localStorage.getItem('referral-registration') || '';
    if (referral_registration !== '') {
      const error_message_registration = (this.elements.registrationErrors && !this.elements.registrationErrors.classList.contains('visually-hidden')) ? this.elements.registrationErrors.innerHTML : '';

      if (error_message_registration !== '') {
        window.localStorage.setItem('referral-registration-errors', error_message_registration);
        window.location.href = `/account/register?view=referral`;
        return;
      }
    }
  };
  
  // resetPasswordSuccess() {
  //   const formSuccess = document.querySelector('.reset-password-success');
  //   if (!formSuccess) {
  //     return;
  //   }

  //   formSuccess.classList.remove('hide');
  //   formSuccess.focus();
  // }

  changeTab = (e) => {
    // URL can be either /account/login or /account/register
    // or /account/login?form=login or /account/register?form=login
    // or /account/login?form=register or /account/register?form=register
    let show_form = (window.location.pathname.includes('login')) ? 'login' : 'register';
    if (window.location.search.includes('form=login')) {
      show_form = 'login';
    }
    if (window.location.search.includes('form=register')) {
      show_form = 'register';
    }

    let hide_form = (show_form === 'login') ? 'register' : 'login';
    
    if (typeof e !== 'undefined') {
      show_form = (e.currentTarget.dataset.authTabType === 'login') ? 'login' : 'register';
      hide_form = (e.currentTarget.dataset.authTabType === 'login') ? 'register' : 'login';
    }

    document.querySelector(`[data-auth-tab-type="${show_form}"]`).removeAttribute('tabindex');
    document.querySelector(`[data-auth-tab-type="${show_form}"]`).classList.add('active');
    document.querySelector(`[data-auth-tab-type="${hide_form}"]`).setAttribute('tabindex', '-1');
    document.querySelector(`[data-auth-tab-type="${hide_form}"]`).classList.remove('active');
    document.querySelector(`[data-form-${show_form}]`).classList.remove('visually-hidden');
    document.querySelector(`[data-form-${hide_form}]`).classList.add('visually-hidden');

    // We come from the referral email; we need an extra form field that will be used 
    // https://astrthelabel.com/discount/GG2060552154326810?redirect=/account/login&promo=referral
    if (show_form === 'login' && window.location.search.includes('promo=referral')) {
      const login_form = document.querySelector('[data-customer-auth-login] #customer_login');
      // <input id="promoField" type="hidden" name="customer[note][promo]" value="referral" />
      const input = document.createElement('input');
      input.setAttribute('id', 'redirectPromoField');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', 'return_to');
      input.setAttribute('value', '/pages/referral-account');
      login_form.appendChild(input);
    }

    // We come from the referral email / shared link; we need an extra form field that will be used 
    // https://www.astrthelabel.com/account/register?promo=referral&referrer=605521543268
    if (show_form === 'register' && window.location.search.includes('promo=referral')) {
      const url = new URL(window.location.href);
      const referrer_id = url.searchParams.get('referrer');

      if (typeof referrer_id !== 'undefined' && referrer_id !== null && referrer_id !== '') {
        const customerReferralRegistration = new CustomerReferralRegistration(referrer_id);
        customerReferralRegistration.updateForm();
        customerReferralRegistration.updateImageContent();
      }
    }
  };

  // Change the view between the tabs and the recover password form
  changeView = (e) => {
    const item = e.currentTarget;
    
    if (item.getAttribute('id') === 'RecoverPassword') {
      this.elements.recoverPasswordContainer.classList.remove('visually-hidden');
      this.elements.loginRegisterContainer.classList.add('visually-hidden');
      return;
    }

    if (item.getAttribute('id') === 'HideRecoverPassword') {
      this.elements.recoverPasswordContainer.classList.add('visually-hidden');
      this.elements.loginRegisterContainer.classList.remove('visually-hidden');
      this.changeTab({ currentTarget: document.querySelector('[data-auth-tab-type="login"]') });
      return;
    }
  };

  handleRegistration = (e) => {
    window.localStorage.removeItem('referral-registration');

    // Specific in case we have multiple forms on the page in the future
    const form = document.querySelector('[data-customer-auth-register] #create_customer');

    if (form.parentNode.querySelector('.errors')) {
      form.parentNode.querySelector('.errors').remove();
    }

    if (!document.getElementById('FirstName').value.length || !document.getElementById('LastName').value.length || !document.getElementById('Email').value.length || !document.getElementById('CreatePassword').value.length) {
      const element = document.createElement('div');
      element.classList.add('errors');
      element.textContent = 'Please fill out all the fields';
      form.parentNode.insertBefore(element, form);

      return;
    }

    form.submit();
  };

  handleLogin = (e) => {
    window.localStorage.removeItem('referral-login');

    // Specific in case we have multiple forms on the page in the future
    const form = document.querySelector('[data-customer-auth-login] #customer_login');

    if (form.parentNode.querySelector('.errors')) {
      form.parentNode.querySelector('.errors').remove();
    }

    if (!document.getElementById('CustomerEmail').value.length || !document.getElementById('CustomerPassword').value.length) {
      const element = document.createElement('div');
      element.classList.add('errors');
      element.textContent = 'Please fill out all the fields';
      form.parentNode.insertBefore(element, form);

      return;
    }

    form.submit();
  };

  handleRecoverPassword = (e) => {
    window.localStorage.removeItem('referral-registration');
    window.localStorage.removeItem('referral-login');

    // Specific in case we have multiple forms on the page in the future
    const form = document.querySelector('[data-customer-auth-recover-password] form');

    if (form.parentNode.querySelector('.errors')) {
      form.parentNode.querySelector('.errors').remove();
    }

    if (!document.getElementById('RecoverEmail').value.length) {
      const element = document.createElement('div');
      element.classList.add('errors');
      element.textContent = 'Please fill out all the fields';
      form.parentNode.insertBefore(element, form);

      return;
    }

    form.submit();
  };
}
